import { useGlobalContext } from '@/core/contexts/GlobalContext/GlobalContext';

import { getBackendImage } from '@/utils/helpers';

import {
  ImageDescription,
  MomentImage,
  SingleBlockContainer,
  StyledMomentVectorCard,
} from './Moment.styles';
import { MomentId } from '../../moments.types';

type MomentProps = {
  components: Array<MomentId>;
  handleOpenModal: (item: MomentId) => void;
  item: MomentId;
}

export const Moment = ({
  handleOpenModal,
  components,
  item,
}: MomentProps) => {
  const { isTabletOrAbove } = useGlobalContext();

  //  I've decided to go with js rather than with css because styled components
  //  had problems when working with multiple `nth-childrens` and variables combined

  const itemMarginStyling: { marginTop?: number | string } = {};

  if (item.id > 0) {
    const previousTitle = components[item.id + 1]?.attributes.title;

    if (!item.attributes.title || !previousTitle) {
      itemMarginStyling.marginTop = 0;
    }
  }

  return (
    <>
      {item?.attributes?.backgroundColor ?
        (
          <StyledMomentVectorCard color={item?.attributes?.backgroundColor} />
        ) :
        (
          <SingleBlockContainer
            onClick={() => handleOpenModal(item)}
            key={item.id}
            style={isTabletOrAbove ? itemMarginStyling : undefined}
          >
            <MomentImage
              src={`${getBackendImage(item?.attributes?.image?.data?.attributes?.url)}`}
              alt={item?.attributes?.image?.data?.attributes.alternativeText ||
                item?.attributes?.title}
            />
            <ImageDescription>{item?.attributes?.title}</ImageDescription>
          </SingleBlockContainer>
        )
        }
    </>
  );
};

